import script from "./ListPropertiesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPropertiesComponent.vue?vue&type=script&setup=true&lang=js"

import "./ListPropertiesComponent.vue?vue&type=style&index=0&id=218ca741&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218ca741"]])

export default __exports__